module.exports = __webpack_public_path__ + "img/COLLEGE LETENDRE.d3ec1ecf.jpg";